import { c as _c } from "react/compiler-runtime";
export type Tone = "ready" | "partial" | "unknown" | "dead" | "accent";
export function Dot(t0) {
  const $ = _c(5);
  const {
    tone: t1,
    size: t2
  } = t0;
  const tone = t1 === undefined ? "ready" as Tone : t1;
  const size = t2 === undefined ? 10 : t2;
  let t3;
  if ($[0] !== size) {
    t3 = {
      width: size,
      height: size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3 || $[3] !== tone) {
    t4 = <span data-tone={tone} className="ui-dot" style={t3} />;
    $[2] = t3;
    $[3] = tone;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}